<div>
  Please wait...
  @if (this.lastRoute) {
    <a [routerLink]="this.lastRoute">return to {{this.lastRoute}}</a>
    <span class='k-icon k-i-loading'></span>
  }

  @if (this.reason) {
    {{ this.reason | json }}
  }

  @if (this.error) {
    {{ this.error | json }}
  }

</div>
